/**
 * Materyal -> geometri onbellegini her kare senkronize eden sistem (beforeRender).
 *
 * Onbellek mantigi MaterialGeometryCache'te kalir; bu sistem yalnizca dogru
 * fazda sync'i tetikler. Engine onbellek ornegini paylasir (proxy metotlari icin).
 */
import type { MaterialGeometryCache } from "../MaterialGeometryCache";
import type { EngineSystem, FrameContext, FramePhase } from "../runtime/EngineSystem";

export class MaterialGeometryCacheSystem implements EngineSystem {
  readonly name = "matGeomCache";
  readonly labels: Partial<Record<FramePhase, string>> = {
    beforeRender: "matGeomCache.sync",
  };

  constructor(private readonly _cache: MaterialGeometryCache) {}

  beforeRender(ctx: FrameContext): void {
    this._cache.sync(ctx.engine.activeScene);
  }
}
